export enum PreferenceType {
    TutorialLink = '3ce48c0e-54a1-4681-aedf-2d720d0b7fb2',
    BusinessSignUpMessage = 'fcd6edf7-2c71-435d-8f55-41057fcae462',
    BusinessSignUpRedirectLink = 'fe754320-a0aa-424e-afa2-dbfe8fef4171',
    BusinessPostJobMessage = 'aa15a19b-7e3e-44a8-baaa-0b575054b774',
    MissingStreetNumberMessage = 'fb4d409b-c34a-4183-b233-1187b1b54787',
    ActiveJobOnRepostMessage = 'b0d1caa3-77aa-4d2a-809a-85b024f4afc0',
    WaitingForBidsMessage = '4b3d715b-b388-4379-9c23-177f78555502',
    TwoJobPicturesMessage = '1cd0c1f3-3f53-4c6c-aa02-69a50df8141e'
}



// WEBPACK FOOTER //
// ./src/types/enums/PreferenceType.ts